import userProfile from './userprofile';
import authorization from './authorization';
import appActions from './app';
import newOrder from './new-order';
import catalog from './catalog';
import order from './order';
import bulkUpload from './bulk-upload';
import PObulkUpload from './po-bulk-upload';
import uam from './uam';
import users from './users';
import reports from './reports';
import customizedReports from './customized-reports';
import exportPartnerFinancials from './export-partner-financials';
import surveys from './surveys';
import priceList from './price-list';
import customerPriceList from './customer-price-list';
import quote from './quote';
import directQuoteTemp from './directQuoteTemp';
import directCustomerQuote from './direct-customer-quote';
import deal from './deal';
import salesCompensation from './salesCompensation';
import payment from './payment';
import directCheckout from './direct-checkout';
import directCustomers from './directCustomers';
import indirectCustomers from './indirectCustomers';
import quoteDetails from './quoteDetails';
import myPayments from './myPayments';
import directCustomerCTQuotes from './direct-customer-ct-quotes';
import indirectCustomerCTQuotes from './indirect-customer-ct-quotes';
import directCustomerPayments from './directCustomerPayments';
import businesReportActions from './business-reports';
import tableFilters from './table-filters';
import customerEntity from './customerEntity';

const actions = {
    userProfile: userProfile,
    authorization: authorization,
    app: appActions,
    newOrder: newOrder,
    catalog: catalog,
    order: order,
    bulkUpload: bulkUpload,
    PObulkUpload: PObulkUpload,
    uam: uam,
    users: users,
    reports: reports,
    surveys: surveys,
    priceList: priceList,
    customerPriceList: customerPriceList,
    quote: quote,
    directQuoteTemp: directQuoteTemp,
    directCustomerQuote: directCustomerQuote,
    deal: deal,
    salesCompensation: salesCompensation,
    payment: payment,
    directCheckout: directCheckout,
    directCustomers: directCustomers,
    indirectCustomers: indirectCustomers,
    customizedReports: customizedReports,
    exportPartnerFinancials: exportPartnerFinancials,
    quoteDetails: quoteDetails,
    myPayments: myPayments,
    directCustomerCTQuotes: directCustomerCTQuotes,
    indirectCustomerCTQuotes: indirectCustomerCTQuotes,
    directCustomerPayments: directCustomerPayments,
    businesReportActions: businesReportActions,
    tableFilters:tableFilters,
    customerEntity: customerEntity
};

export default actions;